<template>
    <div @click="handleSetLanguage">
        <img v-if="language === 'zh'" src="../../assets/images/language_zh.png" class="img_lang">
        <img v-else src="../../assets/images/language_en.png" class="img_lang">
    </div>
</template>

<script>
export default {
    computed: {
        language() {
            return this.$store.getters.language
        }
    },
    methods: {
        handleSetLanguage() {
            const lang = this.language === 'zh' ? 'en' : 'zh'
            this.$i18n.locale = lang
            this.$store.dispatch('app/setLanguage', lang)
            this.$message({
                message: 'Switch Language Success',
                type: 'success'
            })
            location.reload()
        }
    }

}
</script>

<style lang="less" scoped>
    .img_lang{
        width: 22px;
        height: 22px;
    }
</style>
